import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Tambahkan useNavigate
import { useAuth } from '../context/AuthContext';
import { FaUser, FaLock, FaSignInAlt, FaBuilding, FaEye, FaEyeSlash, FaEnvelope } from 'react-icons/fa';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { login, isAuthenticated } = useAuth();
    const navigate = useNavigate();

    // Jika sudah login, redirect ke admin
    React.useEffect(() => {
        if (isAuthenticated) {
            navigate('/admin', { replace: true });
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        // Panggil login dan TUNGGU hasilnya dengan await
        const result = await login(email, password);

        if (!result.success) {
            setError(result.message);
            setIsLoading(false);
        } else {
            // Login berhasil, redirect ke admin
            navigate('/admin', { replace: true });
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-[#F8FAFC] to-[#E2E8F0] flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo & Header */}
                <div className="text-center mb-8">
                    <div className="w-20 h-20 bg-gradient-to-br from-[#0F4C3A] to-[#2E7D32] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
                        <FaBuilding className="text-4xl text-white" />
                    </div>
                    <h1 className="text-2xl font-bold text-[#0F4C3A]">Admin Panel</h1>
                    <p className="text-gray-600 mt-1">BPKAD Kota Magelang</p>
                </div>

                {/* Login Form */}
                <div className="bg-white rounded-2xl shadow-xl p-8">
                    <h2 className="text-xl font-bold text-[#0F172A] mb-6 flex items-center">
                        <FaSignInAlt className="mr-2 text-[#2E7D32]" />
                        Masuk ke Dashboard
                    </h2>

                    {error && (
                        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6 flex items-center">
                            <span className="mr-2">⚠️</span>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Email
                            </label>
                            <div className="relative">
                                <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2E7D32] focus:border-transparent transition-all"
                                    placeholder="Masukkan email"
                                    required
                                />
                            </div>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Password
                            </label>
                            <div className="relative">
                                <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#2E7D32] focus:border-transparent transition-all"
                                    placeholder="Masukkan password"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>
                        </div>

                        <div className="flex items-center justify-between text-sm">
                            <label className="flex items-center">
                                <input type="checkbox" className="mr-2 text-[#2E7D32] focus:ring-[#2E7D32]" />
                                <span className="text-gray-600">Ingat saya</span>
                            </label>
                            <a href="#" className="text-[#2E7D32] hover:text-[#4CAF50]">Lupa password?</a>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className={`w-full bg-gradient-to-r from-[#0F4C3A] to-[#2E7D32] text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 flex items-center justify-center ${isLoading ? 'opacity-75 cursor-not-allowed' : ''
                                }`}
                        >
                            {isLoading ? (
                                <>
                                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                                    Memproses...
                                </>
                            ) : (
                                <>
                                    <FaSignInAlt className="mr-2" />
                                    Masuk
                                </>
                            )}
                        </button>
                    </form>
                </div>

                <p className="text-center text-gray-500 text-sm mt-6">
                    © 2026 BPKAD Kota Magelang. All rights reserved.
                </p>
            </div>
        </div>
    );
};

export default LoginPage;